<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text"
        ><v-toolbar-title>THÊM MÔN HỌC BỔ TRỢ</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-form ref="form" flat class="pt-5">
          <div class="d-flex pt-2">
            <AutocompleteSubjectGroup
              return-object
              item-text="title"
              item-value="id"
              label="Bộ môn"
              class="required"
              deletable-chips
              dense
              :rules="[$rules.required]"
              required
              outlined
              v-model="subjectGroup"
            />
          </div>
          <div class="d-flex mr-4">
            <AutocompleteGrade
              return-object
              v-model="grade"
              item-text="title"
              item-value="id"
              label="Khối"
              class="col-md-6 mr-4"
              dense
              outlined
            />
            <AutocompleteDivision
              return-object
              v-model="division"
              item-text="title"
              item-value="id"
              label="Phân ban"
              class="col-md-6"
              clear-icon="mdi-close"
              outlined
              dense
              deletable-chips
            />
          </div>
          <div class="mb-2">
            <v-text-field
              label="Tên môn học"
              class="required"
              :rules="[$rules.required, titleRule]"
              v-model="title"
              dense
              outlined
              required
            ></v-text-field>
          </div>
          <div class="mt-n2">
            <v-text-field
              label="Hệ số tổng kết"
              :rules="[$rules.min(0)]"
              v-model="multiply"
              dense
              outlined
              type="number"
            ></v-text-field>
          </div>
          <v-radio-group row class="shrink mt-n2" mandatory v-model="markType">
            <v-radio label="Đánh giá theo điểm số" hide-details value="mark"></v-radio>
            <v-radio label="Đánh giá theo nhận xét" hide-details value="evaluate"></v-radio>
          </v-radio-group>
          <div class="d-flex"></div>
          <div class="d-flex mr-4">
            <v-text-field
              label="Số tiết tối thiểu trên tuần"
              class="required col-md-6 mr-4"
              :rules="[$rules.required, $rules.min(0), $rules.max(maxWeeklyLesson)]"
              min="0"
              v-model="minWeeklyLesson"
              dense
              outlined
              required
              type="number"
            ></v-text-field>
            <v-text-field
              label="Số tiết tối đa trên tuần"
              class="required col-md-6"
              :rules="[$rules.required, $rules.min(0), $rules.min(minWeeklyLesson)]"
              min="0"
              v-model="maxWeeklyLesson"
              dense
              outlined
              required
              type="number"
            ></v-text-field>
          </div>
          <v-checkbox v-model="compoundClass" label="Ghép lớp" class="mt-n2 mb-n4"> </v-checkbox>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="gray--text" depressed outlined @click="cancel">HUỶ</v-btn>
        <v-btn depressed color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteDivision from '@/components/basic/input/AutocompleteDivision'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import { textHelpers } from '@/helpers/TextHelper.js'
import { mapActions, mapState } from 'vuex'
import { get, map, chunk } from 'lodash'
import { Class, Teaching } from '../../plugins/api'

export default {
  components: { AutocompleteSubjectGroup, AutocompleteGrade, AutocompleteDivision },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false,
      title: '',
      grade: '',
      markType: 'mark',
      multiply: '',
      division: '',
      type: '',
      lessonPerYear: '',
      minWeeklyLesson: '',
      maxWeeklyLesson: '',
      compoundClass: false,
      subjectGroup: '',
      titleRule: v => {
        const title = textHelpers.removeSpaces(v)
        return !map(this.subjects, 'title').includes(title) || 'Đã có môn học này'
      }
    }
  },
  computed: {
    ...mapState('subjects', ['subjects'])
  },
  methods: {
    ...mapActions('subjects', ['createSubject']),
    async save() {
      if (this.$refs.form.validate()) {
        try {
          this.$loading.active = true
          const data = {
            title: textHelpers.removeSpaces(this.title),
            type: 'extraCurriculum',
            markType: this.markType,
            multiply: this.multiply,
            grade: get(this.grade, 'id'),
            division: get(this.division, 'id'),
            subjectGroup: this.subjectGroup.id,
            data: {
              lessonPerYear: this.lessonPerYear,
              minWeeklyLesson: this.minWeeklyLesson,
              maxWeeklyLesson: this.maxWeeklyLesson,
              compoundClass: this.compoundClass
            }
          }
          const subject = await this.createSubject({ ...data })
          const classes = await Class.fetch({
            division: get(this.division, 'id'),
            grade: get(this.grade, 'id'),
            _limit: -1
          })

          const sgIndex = `00${subject.subjectGroup && subject.subjectGroup.index}`.substr(
            `00${subject.subjectGroup && subject.subjectGroup.index}`.length - 2
          )
          const groups = chunk(classes, 5)
          for (let subClasses of groups) {
            await Promise.all(
              subClasses.map(async c => {
                const grade = `00${get(c, 'grade.gradeNumber', '')}`.substr(`00${get(c, 'grade.gradeNumber', '')}`.length - 2)
                const tags = grade + c.title + sgIndex

                await Teaching.create({
                  class: c.id,
                  grade: c.grade.id,
                  subject: subject.id,
                  subjectGroup: get(subject.subjectGroup, 'id'),
                  tags
                })
              })
            )
          }

          this.$alert.addSuccess()
          this.$refs.form.reset()
          this.dialog = false
        } catch (error) {
          console.error('error: ', error)
          this.$alert.addError(error)
        } finally {
          this.$loading.active = false
        }
      }
    },
    cancel() {
      this.dialog = false
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    maxWeeklyLesson: 'resetValidation',
    minWeeklyLesson: 'resetValidation'
  }
}
</script>
